import { Box, Dialog, Stack, SxProps, Theme } from "@mui/material";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { ResponsiveStyleValue } from "@mui/system";
import { useMemo, useState } from "react";

import { GeneralAddressDto } from "@/core/api/generated/v1";

import AppModalTitle from "../../../Modals/AppModalTitle";
import { GeneralAddressDisplay } from "./GeneralAddressDisplay";

interface Props {
  address?: GeneralAddressDto;
  direction?: ResponsiveStyleValue<"row" | "column" | "column-reverse" | "row-reverse">;
  sx?: SxProps<Theme>;
}

export default function GeneralAddressCompactDisplay({ address, direction = "column", sx }: Props) {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const textLine1 = useMemo(
    () => [address?.line1, address?.line2].filter((x) => !!x).join(", "),
    [address],
  );
  const textLine2 = useMemo(
    () => [address?.city, address?.state, address?.postalCode].filter((x) => !!x).join(", "),
    [address],
  );
  const textLine3 = useMemo(() => [address?.country].filter((x) => !!x).join(", "), [address]);

  return (
    <>
      <Box sx={{ cursor: "pointer", ...sx }} onClick={() => setIsDetailsModalOpen(true)}>
        <Stack direction={direction} spacing={direction == "row" ? 1 : 0}>
          {textLine1 && <Box>{textLine1}</Box>}
          {textLine2 && <Box>{textLine2}</Box>}
          {textLine3 && <Box>{textLine3}</Box>}
        </Stack>
      </Box>

      {address && (
        <Dialog
          maxWidth='md'
          fullWidth
          open={isDetailsModalOpen}
          onClose={() => setIsDetailsModalOpen(false)}
        >
          <AppModalTitle onClose={() => setIsDetailsModalOpen(false)}>
            Address details
          </AppModalTitle>
          <DialogContent>
            <GeneralAddressDisplay address={address} />
          </DialogContent>
          <DialogActions>
            <Button variant='text' onClick={() => setIsDetailsModalOpen(false)}>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
